import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('StarterPackPage').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '8px',
    gap: '12px',
    paddingTop: '16px',
    paddingBottom: '72px',
  },

  heading: {
    fontWeight: 450,
    fontSize: '24px',
    color: 'white',
    textAlign: 'center',
  },
  description: {
    fontWeight: 450,
    fontSize: '17px',
    textAlign: 'center',
    color: theme.colors.text.secondary,
  },

  imageWrapper: {
    position: 'relative',
  },

  discountContainer: {
    position: 'absolute',
    top: '0',
    right: '0',
    width: '94px',
    height: '46px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0px 10px 20px 0px rgba(0, 0, 0, 0.6)',
    borderRadius: '24px',
    background: 'linear-gradient(180deg, #5EBEF0 0%, #0395FD 100%)',
  },

  discountText: {
    fontWeight: 700,
    fontFamily: 'Space Grotesk',
    fontSize: '30px',
    color: 'white',
  },

  packImage: {
    width: '300px',
  },

  packContainsText: {
    fontSize: '13px',
    fontWeight: 370,
    textAlign: 'center',
    color: theme.colors.text.secondary,
    textTransform: 'uppercase',
  },

  starterPackList: {
    display: 'flex',
    gap: '32px',
    flexWrap: 'wrap',
    width: '100%',
    justifyContent: 'center',
  },

  timeLeftWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'center',
  },

  expiresText: {
    fontSize: '13px',
    fontWeight: 250,
    alignItems: 'center',
    color: theme.colors.text.secondary,
  },

  timeLeftContainer: {
    display: 'flex',
    gap: '8px',
  },

  daysWrapper: {
    background: 'rgba(17, 17, 17, 1)',
    padding: '5px 6px',
    display: 'flex',
    width: 'fit-content',
    borderRadius: '4px',
    boxShadow: '0px 1px 0px 0px rgba(0, 0, 0, 1) inset, 0px 1px 0px 0px rgba(72, 72, 72, 1)',
    span: {
      fontWeight: 400,
      fontFamily: 'Space Grotesk, Inter',
      fontSize: '20px',
      color: theme.colors.text.primary,
    },
  },

  openForWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',

    span: {
      fontSize: '17px',
    },
  },
  button: {
    width: '100%',
    height: '52px',
    gap: '8px',
  },

  strikethroughContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px 12px',
    gap: '4px',
    borderRadius: '24px',
    background: 'rgba(55, 85, 219, 1)',

    span: {
      fontSize: '17px',
      textDecoration: 'line-through',
      color: 'white',
    },
  },
}))
